// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

    // apiBaseUrl: 'http://tnsacs.xenovex.com/cmsapi',
    apiBaseUrl: ' https://tnsacs.in/cmsapi',
    //apiBaseUrl: 'http://localhost:52753',
    //apiBaseUrl: 'http://192.168.0.226:9200',
    //apiBaseUrl: 'http://1.22.172.218:10501',
    tokenEndPoint: '/api/token',
    production: false,
    environment: 'Local',
    showEnvironment: true
};


